module.exports = __webpack_public_path__ + "static/media/special-offers.4a9c71cb.svg";